import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col, Input } from 'reactstrap';

import { getLanguagePath } from '../../Intl/IntlActions';

import FontCustom from '../../../components/Content/FontCustom';

import config from '../../../config';

const AppContact = ({ hideEmail, fullWidth, ...props }) => {
    return (
        <div className={classnames(!fullWidth && ['py-4', 'px-1', 'px-md-3'], 'bg-quaternary')}>
            <Row noGutters={!fullWidth}>
                <Col xs="3" sm={fullWidth ? 2 : 3} className="text-center">
                    <FontCustom name="contact" size="4.5" />
                </Col>
                <Col>
                    <span className="h1"><FormattedMessage id="contactTitle" defaultMessage="Contact" /></span>
                    <p className="text-primary">
                        <FormattedMessage id="contactInfoText" defaultMessage="For any questions on product or your order" />
                    </p>
                </Col>
            </Row>
            <div className="d-flex justify-content-center font-weight-bold text-lg special-font">
                <a href={`tel:${config.application.phone}`} className={classnames('mr-2', 'pr-2', 'mr-lg-4', 'pr-lg-4', !hideEmail && ['border-right', 'border-primary'], 'text-white')}>{config.application.phone}</a>
                {!hideEmail && <Link to={getLanguagePath('/contact', props.intl.locale)} className="text-white"><FormattedMessage id="contactByEmail" defaultMessage="By email" /></Link>}
            </div>
        </div>
    );
};

AppContact.defaultProps = {
    hideEmail: false,
    fullWidth: false,
};

AppContact.propTypes = {
    intl: intlShape.isRequired,
    hideEmail: PropTypes.bool,
    fullWidth: PropTypes.bool,
};

export default injectIntl(AppContact);
